import { config } from '../../config';
import request from '../utils/request';

import { HTTP_METHOD } from '../../_types/http-method';
import type { AuthTokensResponse } from '../types/api/auth';

const { AUTH, IS_STG_ENV } = config();

export function exchangeTokens({
  accessToken,
  code,
  idToken,
  refreshToken,
}: { code?: string } & Partial<AuthTokensResponse>) {
  // In staging, allow bypassing the token exchange for easier testing with pre-generated tokens
  if (IS_STG_ENV && accessToken && idToken && refreshToken) {
    const preGeneratedToken: AuthTokensResponse = {
      accessToken,
      expiresIn: 3600,
      idToken,
      refreshToken,
      tokenType: 'Bearer',
    };

    return Promise.resolve(preGeneratedToken);
  }

  if (!code) {
    throw new Error('Missing authorization code');
  }

  return request<AuthTokensResponse>({
    url: `${AUTH.API.v0}${AUTH.PATHS.TOKEN}`,
    options: {
      method: HTTP_METHOD.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: {
        client_id: AUTH.CLIENT_ID,
        code,
        grant_type: AUTH.GRANT_TYPES.EXCHANGE,
        redirect_uri: AUTH.LOGIN_REDIRECT_URL,
      },
    },
    auth: false,
  });
}

export function refreshToken({ refreshToken }: { refreshToken: string }) {
  return request<Omit<AuthTokensResponse, 'refreshToken'>>({
    url: `${AUTH.API.v0}${AUTH.PATHS.TOKEN}`,
    options: {
      method: HTTP_METHOD.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: {
        client_id: AUTH.CLIENT_ID,
        grant_type: AUTH.GRANT_TYPES.REFRESH,
        refresh_token: refreshToken,
      },
    },
    auth: false,
  });
}
